/*
 * Commerce DNA — stand the sticky Add to Cart down while the reviews are on screen.
 *
 * The sticky ATC is `position: fixed; z-index: 2` at the viewport bottom and
 * Okendo's widget is ordinary static content, so the bar always won the stack and
 * sat on top of live review text for the whole scroll (confirmed 2026-07-17: 8
 * Okendo elements intersecting the bar at once). Not a z-index bug — raising Okendo
 * would just bury the ATC behind the reviews instead. The bar has to stand down
 * while reviews are being read, then come back.
 *
 * Keyed off the reviews block rather than a scroll offset: its position depends on
 * how much content sits above it, so a hardcoded offset would drift the moment a
 * section is added or reordered.
 */
(function () {
  var SUPPRESSED = 'cdna-atc-suppressed';

  var sticky = document.querySelector('product-sticky-add-to-cart');
  if (!sticky) return; // sticky ATC off in the theme editor, or product sold out

  /*
   * Observe Shopify's app-block wrapper, NOT Okendo's own `.okeReviews.oke-w`.
   * Two reasons, both learned the hard way:
   *
   *  1. Okendo REPLACES its container element when it renders, so an observer
   *     attached to `.okeReviews.oke-w` ends up watching a detached node and never
   *     fires again — silently. The wrapper is server-rendered Liquid: it exists at
   *     parse time and Okendo never swaps it, so there's no race to lose.
   *  2. `.okeReviews` is on BOTH Okendo blocks — the star-rating summary up in the
   *     buy zone (~19px) and the reviews widget (~2400px). Matching the wrong one
   *     hides the bar right where it's supposed to appear. The wrapper id
   *     distinguishes them; the star rating's id says `okendo_star_rating`.
   *
   * The wrapper is exactly as tall as the widget, so intersecting it is equivalent.
   */
  var reviewsBlock = document.querySelector('.shopify-app-block[id*="okendo_reviews"]');
  if (!reviewsBlock) return; // reviews widget not on this template — nothing to dodge

  var observer = new IntersectionObserver(
    function (entries) {
      var reviewsOnScreen = entries.some(function (entry) {
        return entry.isIntersecting;
      });
      sticky.classList.toggle(SUPPRESSED, reviewsOnScreen);
    },
    { threshold: 0 }
  );

  observer.observe(reviewsBlock);

  // Hold a reference so the observer can't be collected, and leave a trace saying
  // the watch is live — this failed silently once and nothing in the DOM
  // distinguished "running but watching a dead node" from "never ran".
  sticky._cdnaReviewsObserver = observer;
  reviewsBlock.setAttribute('data-cdna-atc-watched', '');
})();
